import React from 'react'

const Cpp_tog = () => {
    return (
        <div className='container'>
            <h1>Program to toggle all characters in a string</h1>
            <br />
            <p>Given a string, the task is to toggle all the characters of the string i.e Given a string, the 
                task is to toggle all the characters of the string i.e to convert Upper case to Lower case and
                 vice versa.to convert Upper case to Lower case and vice versa.</p>
             <div className='output'>
             <p><strong>Examples: </strong></p>
             Input  : aBc12# <br />
Output : AbC12#</div>
<p>Traverse the given string, if uppercase characters comes, convert into lowercase and lowercase latter convert
     into uppercase.  </p>
     <div class="containers">
        <div class="line number1 index0 alt2"><code class="comment">// Program to toggle all characters</code>
        </div>
        <div class="line number2 index1 alt1"><code class="library">#include&lt;bits/stdc++.h&gt;</code></div>
        <div class="line number3 index2 alt2"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number4 index3 alt1">&nbsp;</div>
        <div class="line number5 index4 alt2"><code class="library">void</code> <code
                        class="plain">toggleChars(</code><code class="keywords">char</code> <code
                        class="plain">str[])</code></div>
        <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
        <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">for</code> <code class="plain">(</code><code class="keywords">int</code>
                <code class="plain"> i=0; str[i]!=</code><code class="string">'\0'</code><code
                        class="plain">; i++)</code></div>
        <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number9 index8 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">if</code> <code class="plain">(str[i]&gt;=</code><code
                        class="string">'A'</code> <code class="plain">&amp;&amp; str[i]&lt;=</code><code
                        class="string">'Z'</code><code class="plain">)</code></div>
        <div class="line number10 index9 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">str[i] = str[i] + </code><code class="string">'a'</code> <code
                        class="plain">- </code><code class="string">'A'</code><code class="plain">;</code></div>
        <div class="line number11 index10 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">else</code> <code class="library">if</code> <code
                        class="plain">(str[i]&gt;=</code><code class="string">'a'</code> <code
                        class="plain">&amp;&amp; str[i]&lt;=</code><code class="string">'z'</code><code
                        class="plain">)</code></div>
        <div class="line number12 index11 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">str[i] = str[i] + </code><code class="string">'A'</code> <code
                        class="plain">- </code><code class="string">'a'</code><code class="plain">;</code></div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number14 index13 alt1"><code class="plain">&#125;</code></div>
        <div class="line number15 index14 alt2">&nbsp;</div>
        <div class="line number16 index15 alt1"><code class="comment">// Driver code</code></div>
        <div class="line number17 index16 alt2"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number18 index17 alt1"><code class="plain">&#123;</code></div>
        <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">char</code> <code class="plain">str[] = </code><code
                        class="string">"N@@BGeek&"</code><code class="plain">;</code></div>
        <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">toggleChars(str);</code></div>
        <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"String after toggle "</code> <code
                        class="plain">&lt;&lt; endl;</code></div>
        <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; str &lt;&lt; endl;</code></div>
        <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">0;</code></div>
        <div class="line number24 index23 alt1"><code class="plain">&#125;</code></div>
</div>
<div className='output'>
    <p><strong>Output:</strong></p>
String after toggle <br />
n@@bgEEK& <br />
</div>
        </div>
    )
}

export default Cpp_tog
